<template>
  <v-dialog
    transition="dialog-top-transition"
    max-width="600"
    v-model="window.show"
    :retain-focus="false"
  >
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar color="error" dark>
          <v-icon left> mdi-alert-circle-outline </v-icon>
          An error has occurred
        </v-toolbar>
        <v-card-text>
          <br />
          <div>{{ window.text }}</div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            id="error-close-dialog-button"
            text
            @click="dialog.value = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>
<script>
import { createNamespacedHelpers } from "vuex-composition-helpers";
const { useState } = createNamespacedHelpers("ui");

export default {
  created() {
    this.$log.debug();
  },
  setup() {
    const { window } = useState(["window"]);
    return {
      window,
    };
  },
};
</script>
